/**
 * Перезагрузка за новой сборкой мимо кэша. Сначала перечитываем сам документ с `reload` — это обновляет запись
 * в HTTP-кэше браузера (иначе телефон может отдать старый index.html), затем обычная перезагрузка берёт свежий.
 * `fetchImpl` — браузерный fetch composition root (`main.tsx`): прямого fetch вне него в клиенте нет.
 * Хэшированные файлы `/assets/*` новой сборки имеют новые имена и скачиваются сами.
 */
export async function reloadForUpdate(
  fetchImpl: typeof fetch,
  reload: () => void = () => window.location.reload(),
): Promise<void> {
  try {
    await fetchImpl(window.location.pathname, { cache: 'reload', credentials: 'same-origin' })
  } catch {
    // Нет связи: перезагрузка всё равно безвредна, браузер возьмёт что есть.
  }
  reload()
}
